export default {
  passwordLength: 8,
  priceMoreThan: 0,
};
